import { render, staticRenderFns } from "./matter-info.vue?vue&type=template&id=0ea71159&scoped=true"
import script from "./matter-info.vue?vue&type=script&lang=js"
export * from "./matter-info.vue?vue&type=script&lang=js"
import style0 from "./matter-info.vue?vue&type=style&index=0&id=0ea71159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea71159",
  null
  
)

export default component.exports